import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { addOrderNotification } from "../../features/notificationSlice/notificationSlice";
import socket from "../../features/socket";

const OrderNotificationListener = () => {
  const dispatch = useDispatch();
  const userData = JSON.parse(localStorage.getItem("userData"));

  useEffect(() => {
    const handleOrderUpdate = (data) => {
      const {
        orderId,
        customerName,
        updatedBy,
        status,
        onlyStatusUpdated,
        foodItems,
        updatedFields,
      } = data;

      if (updatedBy === userData?.id || updatedBy === userData?.email) return;

      dispatch(addOrderNotification({
        id: `order-update-${orderId}-${Date.now()}`,
        orderId,
        customerName,
        message: "Order updated",
        type: "update",
        time: new Date().toISOString(),
        read: false,
        status: status || "Unknown",
        onlyStatusUpdated: !!onlyStatusUpdated,
        foodItems: foodItems || [],
        updatedFields: updatedFields || [],
      }));
    };

    const handleOrderCreate = (data) => {
      const {
        orderId,
        customerName,
        createdBy,
        status,
        foodItems,
      } = data;

      if (createdBy === userData?.id || createdBy === userData?.email) return;

      dispatch(addOrderNotification({
        id: `order-create-${orderId}-${Date.now()}`,
        orderId,
        customerName,
        message: "New order received",
        type: "new",
        time: new Date().toISOString(),
        read: false,
        status: status || "Pending",
        foodItems: foodItems || [],
      }));
    };

    socket.on("orderUpdated", handleOrderUpdate);
    socket.on("orderCreated", handleOrderCreate);

    return () => {
      socket.off("orderUpdated", handleOrderUpdate);
      socket.off("orderCreated", handleOrderCreate);
    };
  }, [dispatch, userData]);

  return null;
};

export default OrderNotificationListener;
